import { z } from 'zod';
const stats=z.object({inQuarantine:z.number(),iqcPending:z.number(),over24h:z.number(),releasedThisWeek:z.number(),rejectedThisWeek:z.number()});
const dispositions=z.array(z.object({id:z.string(),number:z.string(),productName:z.string(),reasonLabel:z.string(),serial:z.string().nullable()}));
const trend=z.object({rate:z.number().nullable(),previousRate:z.number().nullable(),defects:z.array(z.object({label:z.string(),count:z.number()}))});
const instruments=z.object({rows:z.array(z.object({id:z.string(),kind:z.string(),status:z.string(),nextDue:z.string().nullable()}))});
const audits=z.array(z.object({auditId:z.string(),name:z.string(),status:z.string(),locationCode:z.string().nullable().optional()}));
export const parseStats=(b:any)=>stats.parse(b.data);
export const parseDispositions=(b:any)=>dispositions.parse(b.data);
export const parseTrend=(b:any)=>trend.parse(b.data);
export const parseInstruments=(b:any)=>instruments.parse(b.data);
export const parseAudits=(b:any)=>audits.parse(b.data);
